import * as Yup from 'yup';
import { requiredErrorMessage } from 'constants/constants';
import { STAGE_2 } from 'constants/FarmboxConstants/stage2.constants';

const { TRANSPORTATION_FIELD_NAMES } = STAGE_2;
const { FERTILIZER, SUPPLIER_FIELD, TEMPERATURE_CONTROL_FIELD, PACKAGING } =
  TRANSPORTATION_FIELD_NAMES;

const childSchemaWithoutTempControl = Yup.object({
  [SUPPLIER_FIELD]: Yup.number()
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
});

const childValidationSchema = Yup.object({
  [SUPPLIER_FIELD]: Yup.number()
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
  [TEMPERATURE_CONTROL_FIELD]: Yup.string()
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
});

const fertilizerItemSchema = Yup.object({
  [SUPPLIER_FIELD]: Yup.number()
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
  [TEMPERATURE_CONTROL_FIELD]: Yup.string()
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
  children: Yup.array().of(childValidationSchema),
});

const packagingItemSchema = Yup.object({
  [SUPPLIER_FIELD]: Yup.number()
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
  children: Yup.array().of(childSchemaWithoutTempControl),
});

export const farmTransportationValidationSchema = Yup.object({
  [FERTILIZER]: Yup.array().of(fertilizerItemSchema),
  [PACKAGING]: Yup.array().of(packagingItemSchema),
});
